import { render, staticRenderFns } from "./BoletaEmision.vue?vue&type=template&id=62a22a9e&scoped=true&"
import script from "./BoletaEmision.vue?vue&type=script&lang=js&"
export * from "./BoletaEmision.vue?vue&type=script&lang=js&"
import style0 from "./BoletaEmision.vue?vue&type=style&index=0&id=62a22a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a22a9e",
  null
  
)

export default component.exports